export function isFromAgencyRecord(record) {
  if (!record) return false;
  return !!(
    record.from_agency ||
    (record.booking && record.booking.from_agency)
  );
}

export function isAgencyAccountRecord(record) {
  if (!record) return false;
  const user = record.user;
  return !!(
    record.is_agency ||
    record.isAgency ||
    (user && (user.isAgency || user.is_agency))
  );
}

/** Agency rental or agency user: no complete-info email/link from admin. */
export function isAgencyCompleteProfileRecord(record) {
  return isFromAgencyRecord(record) || isAgencyAccountRecord(record);
}

export function looksLikeRentalRecord(record) {
  if (!record) return false;
  return (
    record.date_1 != null ||
    record.booking_id != null ||
    record.location_id_1 != null ||
    record.vehicle_model_1 != null
  );
}

/**
 * Agencia: pasaporte y licencia van en el rental.
 * Otra persona: van en el cliente creado con el correo del formulario.
 */
export function documentTarget(record, rentalIdOverride) {
  if (!record && !rentalIdOverride) {
    return { clientId: null, rentalId: null };
  }
  const clientId = record
    ? record.client_id ||
      (record.booking && record.booking.client_id) ||
      (record.driver && record.driver.id) ||
      null
    : null;
  const scopedToRental = isFromAgencyRecord(record);
  const rentalId = rentalIdOverride
    ? Number(rentalIdOverride)
    : scopedToRental && looksLikeRentalRecord(record)
      ? Number(record.id)
      : null;
  return {
    clientId: clientId ? Number(clientId) : null,
    rentalId: rentalId && rentalId > 0 ? rentalId : null,
  };
}

export function riderDocumentClientId(record) {
  const target = documentTarget(record);
  return target.clientId;
}



// WEBPACK FOOTER //
// ./src/utils/agencyRiderDocuments.js